"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableLocation = void 0;
var VariableLocation;
(function (VariableLocation) {
    VariableLocation[VariableLocation["Environment"] = 0] = "Environment";
    VariableLocation[VariableLocation["Parameter"] = 1] = "Parameter";
    VariableLocation[VariableLocation["Local"] = 2] = "Local";
    VariableLocation[VariableLocation["Global"] = 3] = "Global";
    VariableLocation[VariableLocation["TDZ"] = 4] = "TDZ";
})(VariableLocation || (exports.VariableLocation = VariableLocation = {}));
